// extracted by mini-css-extract-plugin
export default {"number":"elaborate_number__NW9W2","text":"elaborate_text__SNnZg"};